import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import './styles.scss';

const BANNER_DISMISSED_KEY = 'app_banner_dismissed';
const BANNER_DISMISSED_TIMESTAMP_KEY = 'app_banner_dismissed_timestamp';
const EXPIRATION_HOURS = 24;

const AppBanner = ({ message, isWarning }) => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const dismissed = localStorage.getItem(BANNER_DISMISSED_KEY);
        const dismissedTimestamp = localStorage.getItem(BANNER_DISMISSED_TIMESTAMP_KEY);

        if (dismissed === 'true' && dismissedTimestamp) {
            const dismissedTime = parseInt(dismissedTimestamp, 10);
            const currentTime = Date.now();
            const hoursElapsed = (currentTime - dismissedTime) / (1000 * 60 * 60);

            if (hoursElapsed < EXPIRATION_HOURS) {
                setIsVisible(false);
            } else {
                // Expiration passed, clear localStorage to show banner again
                localStorage.removeItem(BANNER_DISMISSED_KEY);
                localStorage.removeItem(BANNER_DISMISSED_TIMESTAMP_KEY);
            }
        }
    }, []);

    const handleDismiss = () => {
        setIsVisible(false);
        localStorage.setItem(BANNER_DISMISSED_KEY, 'true');
        localStorage.setItem(BANNER_DISMISSED_TIMESTAMP_KEY, Date.now().toString());
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className={`app-banner ${isWarning ? 'app-banner--warning' : 'app-banner--info'}`}>
            <Container fluid className="app-banner__container">
                <div className="app-banner__content">
                    <FontAwesomeIcon icon={faExclamationTriangle} className="app-banner__icon" />
                    <p className="app-banner__text">{message}</p>
                    <button
                        className="app-banner__close"
                        onClick={handleDismiss}
                        aria-label="Banner schließen"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
            </Container>
        </div>
    );
};

AppBanner.propTypes = {
    message: PropTypes.node,
    isWarning: PropTypes.bool,
};

AppBanner.defaultProps = {
    message: (
        <>
            <strong>Hinweis: Website derzeit nicht erreichbar</strong>
            <br /><br />
            Unsere Website ist aus technischen Gründen derzeit leider nicht erreichbar.
            <br /><br />
            Kolleginnen und Kollegen aus dem medizinischen Fachkreis, die unsere bewährten Nährstoff-Kompasse
            sowie praxisorientierten Nährstofftipps nutzen möchten, bitten wir, sich in der Zwischenzeit über
            die Partnerseite von Life Light einzuloggen:<br />
            👉 <a href="https://www.lifelight.com/content/135-partner" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
                https://www.lifelight.com/content/135-partner
            </a>
            <br /><br />
            Neue Interessentinnen und Interessenten, die noch nicht als Partner bei LIFE LIGHT registriert sind,
            bitten wir um individuelle Kontaktaufnahme:
            <br /><br />
            <strong>E-Mail:</strong> <a href="mailto:office@forumviasanitas.org" style={{ color: 'inherit', textDecoration: 'underline' }}>office@forumviasanitas.org</a><br />
            <strong>Info-Hotline:</strong> +43 (0) 6246 21133<br />
            <strong>Servicezeiten:</strong><br />
            Mo–Do: 08:00–17:00 Uhr<br />
            Fr: 08:00–13:00 Uhr
            <br /><br />
            <strong>Vielen Dank für Ihr Verständnis!</strong>
        </>
    ),
    isWarning: true,
};
export default AppBanner;